import React, { Component } from 'react';
import '../Body/Body.scss';
import { DomField, DomBoolCheckbox, DomCheckboxField, DomTextarea } from "../Services/formDOM";
import { checkInput, returnValue, hasValue, validateEmail } from "../Services/Validation";
import { apiURL } from "../Services/Base";
import {GA_Push} from "../Services/GoogleAnalytics";

Object.filter = function (obj, predicate) {
    var result = {}, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key) && predicate(obj[key])) {
            result[key] = obj[key];
        }
    }

    return result;
};
export default class Body extends Component {
    constructor(props) {
        super();
        this.state = {
            isBusy: false,
            isLoading: false,
            isSend: false

        }
    }

    handleInputChange = (event) => {
        const handleChange = {
            [event.target.name]: {
                ...this.state[event.target.name],
                error: "",
                label: event.target.dataset.label ? event.target.dataset.label : "",
                value: (event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value)
            }
        }
        this.setState(handleChange);
    }
    addState = (stateName, isRequired, stateId) => {
        this.setState({
            [stateName]: {
                name: stateName,
                value: "",
                label: "",
                id: stateId,
                isRequired: !isRequired ? false : true
            }
        })
    }
    setErrorMessage = (target, errorMsg) => {
        if (!this.state[target.name]) return;

        this.setState({
            [target.name]: {
                ...target,
                error: errorMsg
            }
        });


    }
    saveAndValidate = async () => {
        if (this.state.isBusy) return;



        this.setState({
            isLoading: true,
            isBusy: true
        });

        let isError = false,
            j = 0,
            jsonBody = {},
            state = Object.filter(this.state, s => s.isRequired),
            fieldStateKeys = Object.keys(state);



        for (let s in state) {
            if (await !checkInput(state[s], this.setErrorMessage)) isError = true;
            j++;
        }

        for (let k in fieldStateKeys) {
            jsonBody = Object.assign(jsonBody, {
                [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
            });
        }

        if (isError && j == fieldStateKeys.length) {
            this.setState({
                isLoading: false,
                isBusy: false
            })
            return;
        }

        console.log(jsonBody);

        fetch(`${apiURL}SendEmail`, {
            method: 'POST',
            headers: {
                'Content-Type': `application/json`
            },
            body: JSON.stringify(jsonBody)
        }).then(data => data.json())
            .then(data => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                })

                GA_Push('form_sent','','goshen80');

            }).catch(error => {
                this.setState({
                    isLoading: false,
                    isBusy: false,
                    isSend: true
                });

            });
    }
    render() {
        return (
            <div>
                <div className="main-mobile">

                    <div className="header">
                        <div className="logo1"></div>
                        <div className="logo2"></div>
                        <div className="logo3"></div>
                    </div>

                    <div className="hero">
                    </div>

                    <div className="info">
                        <div className="headline">
                            פרויקט גושן 80 - קרית מוצקין
        </div>
                        <div className="small-title">
                            חברה: מרדכי י. שמשינס
        </div>
                        <p className="plus">כל הפלוסים בפרויקט אחד!</p>
                        <p className="plus"> דירות הבוטיק – בשדרת גושן שבמרכז העיר </p>

                        <ul className="list">
                            <li>להיות במרכז </li>
                            <li>איכות חיים </li>
                            <li>דירה בקומה </li>
                            <li>מפרט פרמיום </li>
                            <li>מחיר אטרקטיבי </li>
                        </ul>

                        <div className="text">
                            <p>נותרו : </p>
                            <p>6 דירות 5 חדרים עם מחסן קומתי צמוד</p>
                            <p>2 דירות 4 חדרים בקומות העליונות עם מרפסת גן</p>
                            <p>ועכשיו בהזדמנות מיוחדת- דירה אחרונה במחיר השקה </p>
                        </div>
                        <div className="title">
                            הבנייה בעיצומה - איכלוס תוך שנה
        </div>
                        <div className="text">

                            <p>כל הדירות- נבנות בסטנדרט בנייה גבוה ומפרט עשיר, </p>
                            <p>לכל דירה- חנייה צמודה בחניון תת-קרקעי. </p>
                            <p>עיצוב מוקפד, תכנון ובביצוע, ברמה הגבוה ביותר!  </p>
                            <p>במיקום מעולה בקרית מוצקין באחד האזורים הטובים והמבוקשים ביותר.</p>
                        </div>
                    </div>
                    <div className="gallery">
                        <div className="img1"></div>
                        <div className="img2"></div>
                        <div className="img3"></div>
                    </div>

                    <div className="form">

                        <div className={`thanks ${(this.state.isSend ? " show-tnx " : "hide-tnx")}`}>
                            <div className="thanks-title">
                                הפרטים שלכם נשלחו בהצלחה
                                    </div>
                        </div>
                        <div className={`form-info ${(this.state.isSend ? " hide-info " : "show-info")}`}>

                            <div className="form-section">
                                <div className="title">
                                    השאירו פרטים ונציגנו יחזרו אליכם בהקדם:
                         </div>
                                <div className="row">
                                    <DomField
                                        type="text"
                                        max={64}
                                        label=" שם מלא:"
                                        placeholder="שם מלא:"
                                        name="FullName"
                                        id="FullName"
                                        className="field"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} />
                                    <DomField
                                        type="tel"
                                        max={10}
                                        label="טלפון:"
                                        placeholder="טלפון:"
                                        name="PhoneNumber"
                                        id="PhoneNumber"
                                        className="field"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} />
                                </div>

                                <div className="row">
                                    <DomField
                                        type="email"
                                        max={20}
                                        label='מייל:'
                                        placeholder='מייל:'
                                        name="Email"
                                        id="Email"
                                        className="field"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state} />


                                    <div className="send" onClick={this.saveAndValidate}>
                                        <div className="text">שלח פנייה</div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="terms">
                                        <DomBoolCheckbox
                                            type="checkbox"
                                            name="Terms"
                                            id="Terms"
                                            className="field"
                                            label={'המידע יועבר אל שמשינס לצורך פניות שיווקיות'}
                                            value="0"
                                            isRequired
                                            onChange={this.handleInputChange}
                                            onLoad={this.addState}
                                            {...this.state}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer">
                        <div className="details">
                            לפרטים נוספים: 053-9377075
                         </div>
                    </div>
                </div>
                <div className="main-web">
                    <div className="container">

                        <div className="right">
                            <div className="info">
                                <div className="headline">
                                    פרויקט גושן 80 - קרית מוצקין
                             </div>
                                <div className="small-title">
                                    חברה: מרדכי י. שמשינס
                                 </div>
                                <p className="plus">כל הפלוסים בפרויקט אחד!</p>
                                <p className="plus"> דירות הבוטיק – בשדרת גושן שבמרכז העיר </p>

                                <ul className="list">
                                    <li>להיות במרכז </li>
                                    <li>איכות חיים </li>
                                    <li>דירה בקומה </li>
                                    <li>מפרט פרמיום </li>
                                    <li>מחיר אטרקטיבי </li>
                                </ul>

                                <div className="text">
                                    <p>נותרו : </p>
                                    <p>6 דירות 5 חדרים עם מחסן קומתי צמוד</p>
                                    <p>2 דירות 4 חדרים בקומות העליונות עם מרפסת גן</p>
                                    <p>ועכשיו בהזדמנות מיוחדת- דירה אחרונה במחיר השקה </p>
                                </div>
                                <div className="title">
                                    הבנייה בעיצומה - איכלוס תוך שנה
                             </div>
                                <div className="text">

                                    <p>כל הדירות- נבנות בסטנדרט בנייה גבוה ומפרט עשיר, </p>
                                    <p>לכל דירה- חנייה צמודה בחניון תת-קרקעי. </p>
                                    <p>עיצוב מוקפד, תכנון ובביצוע, ברמה הגבוה ביותר!  </p>
                                    <p>במיקום מעולה בקרית מוצקין באחד האזורים הטובים והמבוקשים ביותר.</p>
                                </div>
                            </div>
                            <div className="form">
                                <div className="form-section">
                                    <div className={`thanks ${(this.state.isSend ? " show-tnx " : "hide-tnx")}`}>
                                        <div className="thanks-title">
                                            הפרטים שלכם נשלחו בהצלחה
                                    </div>

                                    </div>
                                    <div className={`form-info ${(this.state.isSend ? " hide-info " : "show-info")}`}>
                                        <div className="title">
                                            השאירו פרטים ונציגנו יחזרו אליכם בהקדם:
                                     </div>
                                        <div className="row">
                                            <DomField
                                                type="text"
                                                max={64}
                                                label="שם מלא:"
                                                placeholder="שם מלא:"
                                                name="FullName"
                                                id="FullName"
                                                className="field"
                                                isRequired
                                                onChange={this.handleInputChange}
                                                onLoad={this.addState}
                                                {...this.state} />
                                            <DomField
                                                type="tel"
                                                max={10}
                                                label="טלפון:"
                                                placeholder="טלפון:"
                                                name="PhoneNumber"
                                                id="PhoneNumber"
                                                className="field"
                                                isRequired
                                                onChange={this.handleInputChange}
                                                onLoad={this.addState}
                                                {...this.state} />
                                        </div>

                                        <div className="row">
                                            <DomField
                                                type="email"
                                                max={20}
                                                label='מייל:'
                                                placeholder='מייל:'
                                                name="Email"
                                                id="Email"
                                                className="field"
                                                isRequired
                                                onChange={this.handleInputChange}
                                                onLoad={this.addState}
                                                {...this.state} />


                                            <div className="send" onClick={this.saveAndValidate}>
                                                <div className="text">שלח פנייה</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="terms">
                                                <DomBoolCheckbox
                                                    type="checkbox"
                                                    name="Terms"
                                                    id="Terms"
                                                    className="field"
                                                    label={'המידע יועבר אל שמשינס לצורך פניות שיווקיות'}
                                                    value="0"
                                                    isRequired
                                                    onChange={this.handleInputChange}
                                                    onLoad={this.addState}
                                                    {...this.state}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="footer">
                                    <div className="details">
                                        לפרטים נוספים: 053-9377075
                             </div>
                                </div>
                            </div>
                        </div>

                        <div className="left">
                            <div className="header">
                                <div className="logo1"></div>
                                <div className="logo2"></div>
                                <div className="logo3"></div>
                            </div>

                            <div className="hero">
                            </div>


                            <div className="gallery">
                                <div className="img1"></div>
                                <div className="img2"></div>
                                <div className="img3"></div>
                            </div>



                        </div>
                    </div>

                </div>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/Components/Body/Body.jsx